document.addEventListener('alpine:init', () => {
    Alpine.data('admin_credits_management_index_x_data', () => ({
        selected: 'Demographics',
        demographics_credits_per_show: [],
        demographics_credits_per_show_filter: '',
        consumption_data: [],
        chart_view: 'all',
        chart_data: null,
        loaded_data: false,
        loading_chart: false,
        init() {
            this.get_demographics_credits_per_show()
            this.$watch('chart_view', val => {
                this.get_usage_overtime()
            })
            this.chart_data = JSON.parse(this.$el.dataset.chartData)
            this.render_chart()
        },
        get_demographics_credits_per_show() {
            const CREDITS_MANAGEMENT_DATA = document.getElementById('credits-management').dataset
            const creditsPerShowUrl = CREDITS_MANAGEMENT_DATA.creditsPerShowUrl
            fetch(creditsPerShowUrl)
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    this.demographics_credits_per_show = data.demographics_shows
                    this.consumption_data = data.total_consumption_data
                    this.loaded_data = true
                })
        },
        get filtered_demographics_credits_per_show() {
            return this.demographics_credits_per_show.filter(item => {
                return item.show_title.toLowerCase().includes(this.demographics_credits_per_show_filter.toLowerCase());
            })
        },
        format_number(number) {
            if (number === null || number === '') {
                return '0';
            }

            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(parseFloat(number));
        },
        render_chart() {
            new Chartkick.AreaChart('line-chart', this.chart_data, {
                colors: ["#CDC1ED"],
            })
        },
        get_usage_overtime() {
            this.loading_chart = true
            const usageUrl = `/admin/users/credits-management/usage?chart_view=${this.chart_view}`
            fetch(usageUrl)
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    this.chart_data = data.chart_data
                    this.render_chart()
                })
                .finally(() => this.loading_chart = false)
        },
        download_demographics_credits_csv() {
            // Select the table
            const table = document.getElementById("demographics_credits_table");
            const rows = Array.from(table.rows);

            // Process each row
            const csvData = rows.map(row => {
                const cells = Array.from(row.cells);
                return cells.slice(0, -1) // Exclude the last cell
                    .map(cell => `"${cell.innerText.replace(/"/g, '""')}"`)
                    .join(",");
            }).join("\n");

            // Create and download the CSV file
            const blob = new Blob([csvData], {type: "text/csv"});
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "table_data.csv";
            a.click();
            URL.revokeObjectURL(url);
        }
    }))
})